/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImpersonationEndpointRequest
 */
export interface ImpersonationEndpointRequest {
    /**
     * 
     * @type {number}
     * @memberof ImpersonationEndpointRequest
     */
    user: number;
}

export function ImpersonationEndpointRequestFromJSON(json: any): ImpersonationEndpointRequest {
    return ImpersonationEndpointRequestFromJSONTyped(json, false);
}

export function ImpersonationEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImpersonationEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
    };
}

export function ImpersonationEndpointRequestToJSON(value?: ImpersonationEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
    };
}


